<template>
  <div class="w-100">
    <validation-observer ref="observer" class="w-100">
      <div class="w-100">
        <b-form-group :label="$t('message.Username')">
          <validation-provider
              #default="{ errors }"
              :name="$t('message.Username')"
              rules="required"
          >
            <b-input v-model="form.name" required></b-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </div>
      <div class="w-100">
        <b-form-group :label="$t('message.First_name')">
          <validation-provider
              #default="{ errors }"
              :name="$t('message.First_name')"
              rules="required"
          >
            <b-input v-model="form.firstname" required></b-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </div>
      <div class="w-100">
        <b-form-group :label="$t('message.Last_name')">
          <validation-provider
              #default="{ errors }"
              :name="$t('message.Last_name')"
              rules="required"
          >
            <b-input v-model="form.lastname" required></b-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </div>
      <div class="w-100">
        <b-form-group :label="$t('message.Email')">
          <validation-provider
              #default="{ errors }"
              :name="$t('message.Email')"
              rules="required"
          >
            <b-input v-model="form.email" required></b-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </div>
      <div class="w-100">
        <b-form-group :label="$t('message.Mobile_number')">
          <b-form-input placeholder="Telefon raqami" v-model="form.mobile" v-mask="'+998(##)###-##-##'"></b-form-input>
        </b-form-group>
      </div>
      <div v-if="!id" class="w-100">
        <b-form-group :label="$t('message.Password')">
          <validation-provider
              #default="{ errors }"
              :name="$t('message.Password')"
              rules="required"
          >
            <b-input type="password" v-model="form.password" required></b-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </div>
      <div v-else class="w-100">
        <b-form-group :label="$t('message.Password')">
          <b-input type="password" v-model="form.password" required></b-input>
        </b-form-group>
      </div>

    </validation-observer>

    <div class="w-100 d-flex justify-content-end mt-4">
      <b-button variant="primary" @click="submitUser">{{$t('message.Add')}}</b-button>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver  , extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/ru.json';
Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule],
    message: messages[rule]
  });
});

import {mask} from 'vue-the-mask';
import {getUser, storeUser, updateUser} from "../../../../../../api/users";
export default {
  name: "Form",
  directives: {mask,},
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    id: {
      required: true,
    }
  },
  data() {
    return {
      form: {
        name: "",
        firstname: "",
        lastname: "",
        email: "",
        mobile: '',
        role_id: 1,
        password: null,
      }
    }
  },
  methods: {
    async submitUser() {
      const isValid = await this.$refs.observer.validate();
      if(isValid) {
        let action = this.id ? updateUser : storeUser;
        action(this.form).then(() => {
          this.$emit('saved');
        })
      }
    },
    fetchUser() {
      getUser(this.id).then(res => {
        this.form = res.data.data;
      })
    }
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        if(val) {
          return this.fetchUser()
        }
        for(let a in this.form) {
          if(a === 'role_id') {
            this.form[a] = 1;
          }
          else{
            this.form[a] = null;
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
